import React, { Component } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import {jsonUrl,equalHeights} from '../components/Factory' 
import Ausstellungen from '../components/Ausstellungen'; 
import Featuredblock from '../components/Featuredblock'; 
import Flexbox from '../components/misc/Flexbox'; 
import AusstellungenItem from '../components/AusstellungenItem'; 

class AusstellungenContainer extends Component {
	constructor(props) {
		super(props);
		this.state = { 
		  list: this.props.resolves.list,
		  offset : 9,
		  finished:'block'
		}
		this.onChange = this.onChange.bind(this);
	}
	onChange(isVisible){
		if(isVisible) { 
			this.loadMore();
		}
	}	
	loadMore(){
		fetch(jsonUrl({ 	number:9,
							offset:this.state.offset,
							type:'ausstellungen',
							meta_key:"exhibition_start_date",
							orderbymeta:'meta_value',
							meta_type:'date',
							order:'desc',
							//meta_query:'&filter[meta_query][0][0][key]=exhibition_start_date&filter[meta_query][0][0][value]='+today()+'&filter[meta_query][0][0][compare]=>=&filter[meta_query][0][0][type]=date&filter[meta_query][0][1][key]=exhibition_end_date&filter[meta_query][0][1][value]='+today()+ '&filter[meta_query][0][1][compare]=>=&filter[meta_query][0][1][type]=date&filter[meta_query][0][relation]=OR'
						}))
					  .then(res => res.json())
					  .then(res => {
							if(res.length>0)
								this.setState({
									list: [...this.state.list,...res],
									offset: this.state.offset+9
								});
							else
								this.setState({
									finished:'none'
								});
							equalHeights('article-item');	
					  })
	}
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
		window.addEventListener('resize', function(){
            if(window.innerWidth<992){
				let total = document.getElementsByClassName('article-item');
				for(let i=0;i<total.length;i++){
					total[i].removeAttribute('style');
				}
			}
        })
	}
	componentDidMount(){	 
		setTimeout(function(){
			document.getElementById('menu-programm').classList.add('active');
			equalHeights('article-item');
		},400);
		
	}
	render() {		
		  const { featured_home_slug,aktuelles_left,aktuelles_right,ruckblick_home_left,ruckblick_home_right,archive_1_label,archive_2_label,archive_1_link,archive_2_link } = this.props.resolves.page;
		  return (
				<div>
					<div className="lg-side-padding container-fluid current-exhibition">
						<Flexbox left={aktuelles_left} right={aktuelles_right} />
						<Featuredblock height={false} {...this.props.resolves.page}/>
					</div>
					<div className="container-fluid lg-side-padding article-list three-col margin-top-50 margin-top-20-mobile">
						<Flexbox left={ruckblick_home_left} right={ruckblick_home_right} />
						<div>
						{
							this.state.list.map( (data,i)=>{
								if(data.slug!==featured_home_slug)
									return <AusstellungenItem {...data} key={i} />		
								else 
									return null
							}) 		
						}
						</div>
						<div className="clearfix" />
						{
						(this.state.list.length>8)?
						<VisibilitySensor onChange={this.onChange}>
							<div className="loading small" style={{display:this.state.finished}}>
								<div className="one"></div>			
							</div>
						</VisibilitySensor>
						:null
						}
						<div className="btns">
							<a target="_blank" href={archive_1_link} aria-label={archive_1_label} className="btn dark-btn">{archive_1_label}</a>
							<a target="_blank" href={archive_2_link} aria-label={archive_2_label} className="btn dark-btn">{archive_2_label}</a>
						</div>
					</div>	
					
				</div>
			)
	   
	}
}
export function getExhibitionList(){
	return fetch(jsonUrl({ 
						number:9,
						type:'ausstellungen',
						meta_key:"exhibition_start_date",
						orderbymeta:'meta_value',
						meta_type:'date',
						order:'desc',
						//meta_query:'&filter[meta_query][0][0][key]=exhibition_start_date&filter[meta_query][0][0][value]='+today()+'&filter[meta_query][0][0][compare]=>=&filter[meta_query][0][0][type]=date&filter[meta_query][0][1][key]=exhibition_end_date&filter[meta_query][0][1][value]='+today()+ '&filter[meta_query][0][1][compare]=>=&filter[meta_query][0][1][type]=date&filter[meta_query][0][relation]=OR'
					}))
				  .then(res => res.json())
				  .then(res => {
					return res;		 
				  })
}
export default AusstellungenContainer;


// WEBPACK FOOTER //
// ./src/containers/AusstellungenContainer.js